

























import Vue from "vue";

import { User } from "../models/User";
import ActHistoryCard from './ActHistoryCard.vue';
import { ActHistory } from '../models/ActHistory';
import { HttpResponse } from "vue-resource/types/vue_resource";

export default Vue.extend({
  name: "ActTimeline",
  props: {
    actId: Number
  },
  components: {
    ActHistoryCard,
  },
  data: () => ({
    loading: false,
    actHistories: [],
    included: []
  }),
  methods: {
    async fetch() {
      this.loading = true;

      ActHistory.fromAct(this.actId, this.$store.state.currentUser.token)
        .then(actHistories =>  this.actHistories = actHistories)
        .catch(e => this.$toast.error(`Une erreur est survenue. (${e.message})`))
        .finally(() => this.loading = false);
    }
  },
  mounted() {
    this.fetch();
  }
});
